/**
 * @generated SignedSource<<c95747526f31c8d06b30633155bc8e6f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type WebBookmarkFetchUrlMetadataMutation$variables = {
  url: string;
};
export type WebBookmarkFetchUrlMetadataMutation$data = {
  readonly fetchUrlMetadata: {
    readonly metadata: {
      readonly description: string | null | undefined;
      readonly image: string | null | undefined;
      readonly title: string | null | undefined;
      readonly url: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type WebBookmarkFetchUrlMetadataMutation = {
  response: WebBookmarkFetchUrlMetadataMutation$data;
  variables: WebBookmarkFetchUrlMetadataMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "url"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "url",
            "variableName": "url"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "FetchUrlMetadataPayload",
    "kind": "LinkedField",
    "name": "fetchUrlMetadata",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UrlMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "image",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WebBookmarkFetchUrlMetadataMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WebBookmarkFetchUrlMetadataMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "884c04ddd3f60f37d22fc942f3def630",
    "id": null,
    "metadata": {},
    "name": "WebBookmarkFetchUrlMetadataMutation",
    "operationKind": "mutation",
    "text": "mutation WebBookmarkFetchUrlMetadataMutation(\n  $url: String!\n) {\n  fetchUrlMetadata(input: {url: $url}) {\n    metadata {\n      url\n      title\n      description\n      image\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "771cee77b1f4f1a42a57335d141a7bff";

export default node;
